import WorkInstructionsHelpMdx from "../../help/work_instructions.mdx";

export function WorkInstructionsHelpPage() {
  return <WorkInstructionsHelpMdx />;
}
